import React from 'react'
import { RetweetOutlined } from 'gokwik-ui-kit'

export default function KwikpassIntegrationIcon() {
    return <RetweetOutlined style={{ fontSize: '24px' }} />
}
